module.exports = __webpack_public_path__ + "img/u53.33bd8f1c.png";